import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRealTimeMonitoring = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 59,
	viewBox: "0 0 57 59",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1253_21492)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M25 50.6396C36.598 50.6396 46 41.2376 46 29.6396C46 18.0417 36.598 8.63965 25 8.63965C13.402 8.63965 4 18.0417 4 29.6396C4 41.2376 13.402 50.6396 25 50.6396Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23 45.6396C35.1503 45.6396 45 35.7899 45 23.6396C45 11.4894 35.1503 1.63965 23 1.63965C10.8497 1.63965 1 11.4894 1 23.6396C1 35.7899 10.8497 45.6396 23 45.6396Z",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.53 42.5599L42.82 55.2799C45.68 58.1399 50.33 58.1399 53.19 55.2799C56.05 52.4199 56.05 47.7699 53.19 44.9099L40.48 35.6299",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.9399 48.5998C37.9399 48.5998 40.7799 48.6398 43.6599 45.7498C46.5499 42.8598 46.5099 40.0298 46.5099 40.0298",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.3701 13.8095C18.1701 8.00947 27.5701 8.00947 33.3601 13.8095",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.4001 30.1299V29.9999C8.4001 28.3299 9.1501 26.9799 11.2201 25.4699C12.5701 24.4799 12.9801 24.1399 12.9801 23.2999C12.9801 22.4599 12.5801 21.9999 11.7701 21.9999C10.8301 21.9999 10.4901 22.5699 10.3601 23.4099H8.3501C8.4901 21.7599 9.5701 20.3799 11.7701 20.3799C14.2301 20.3799 15.0701 21.8499 15.0701 23.2799C15.0701 24.7099 14.4701 25.3499 12.7101 26.5899C11.5301 27.4199 11.0501 27.9699 10.8901 28.3999H15.4301L15.1701 30.1399H8.4001V30.1299Z",
				fill: "#256F94"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.2602 30.1298V27.9798H15.9302V26.1598L19.9302 20.5498H22.2002V26.2898H23.3502L23.1602 27.9698H22.2002V30.1198H20.2702L20.2602 30.1298ZM20.2602 24.5898C20.2602 23.5498 20.2602 22.9698 20.3002 22.3698C19.9202 23.1698 18.6702 24.9998 17.7702 26.2898H20.2602V24.5798V24.5898Z",
				fill: "#256F94"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.1501 33.3797L28.5801 17.4497H30.4801L26.0701 33.3797H24.1501Z",
				fill: "#256F94"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.0001 20.5596V22.1096C36.4801 24.2596 35.0001 27.3596 34.6201 30.1396H32.4801C32.8601 27.3196 34.5701 23.9496 35.8801 22.2796H31.3701V20.5696H38.0001V20.5596Z",
				fill: "#256F94"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1253_21492",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 56.34,
			height: 57.78,
			fill: "white",
			transform: "translate(0 0.639648)"
		})
	}) })]
});
export default SvgRealTimeMonitoring;
